
// src/cache.js
import axios from 'axios'

// Very small in-memory cache for GET requests.
// Keyed by URL + params; respects a simple TTL (default 5 minutes).
const CACHE_TTL_MS = 5 * 60 * 1000
const _cache = new Map()

const defaultAdapter = axios.defaults.adapter // the env-specific adapter

export const cacheAdapter = async (config) => {
  // Only cache GETs without explicit cache-busting
  if ((config.method || 'get').toLowerCase() !== 'get') {
    return defaultAdapter(config)
  }

  const key = JSON.stringify({
    baseURL: config.baseURL || '',
    url: config.url || '',
    params: config.params || {},
    headers: config.headers?.Accept, // narrow cache key if you vary Accept types
  })

  const now = Date.now()
  const hit = _cache.get(key)
  if (hit && (now - hit.timestamp) < (config.cacheTTL || CACHE_TTL_MS)) {
    // Return a shallow-cloned Axios-like response
    return {
      ...hit.response,
      config,
      request: hit.response.request || {},
    }
  }

  // Miss → invoke the real adapter
  const response = await defaultAdapter(config)

  // Store minimal snapshot
  _cache.set(key, {
    timestamp: now,
    response: {
      data: response.data,
      status: response.status,
      statusText: response.statusText,
      headers: response.headers,
      config, // store current config to keep shape
      request: {}, // non-essential
    },
  })

  return response
}
